import { MessageBar } from "@fluentui/react-components";
import React from "react";
import { useSelector } from "react-redux";
import { MenuPublishedState, MessageBarText, StationEditState } from "../../common/commonConstants";
import { notificationStateSelector } from "../../selectors/diningSelector";

export const MenuMessageBar = () => {
  const notificationState = useSelector(notificationStateSelector);
  return (
    <div>
      {notificationState === MenuPublishedState.LOADING ? (
        <MessageBar intent="info" layout="singleline">
          {MessageBarText.LOADING}
        </MessageBar>
      ) : notificationState === MenuPublishedState.CHANGES_PUBLISHED_SUCCESSFULLY ? (
        <MessageBar intent="success" layout="singleline">
          {MessageBarText.CHANGES_PUBLISHED_SUCCESSFULLY}
        </MessageBar>
      ) : notificationState === MenuPublishedState.PUBLISHING_IN_PROGRESS ? (
        <MessageBar intent="info" layout="singleline">
          {MessageBarText.PUBLISHING_IN_PROGRESS}
        </MessageBar>
      ) : notificationState === MenuPublishedState.DELETING_IN_PROGRESS ? (
        <MessageBar intent="info" layout="singleline">
          {MessageBarText.DELETING_IN_PROGRESS}
        </MessageBar>
      ) : notificationState === MenuPublishedState.ITEM_ADDED_TO_BANK_SUCCESSFULLY ? (
        <MessageBar intent="success" layout="singleline">
          {MessageBarText.ITEM_ADDED_TO_BANK_SUCCESSFULLY}
        </MessageBar>
      ) : notificationState === MenuPublishedState.ITEM_REMOVE_FROM_BANK_SUCCESSFULLY ? (
        <MessageBar intent="success" layout="singleline">
          {MessageBarText.ITEM_REMOVE_FROM_BANK_SUCCESSFULLY}
        </MessageBar>
      ) : notificationState === StationEditState.STATION_CREATED_SUCCESSFULLY ? (
        <MessageBar intent="success" layout="singleline">
          {MessageBarText.STATION_CREATED_SUCCESSFULLY}
        </MessageBar>
      ) : notificationState === StationEditState.STATION_DELETED_SUCCESSFULLY ? (
        <MessageBar intent="success" layout="singleline">
          {MessageBarText.STATION_DELETED_SUCCESSFULLY}
        </MessageBar>
      ) : notificationState === MenuPublishedState.ITEM_SAVED_TO_MENU_SUCCESSFULLY ? (
        <MessageBar intent="success" layout="singleline">
          {MenuPublishedState.ITEM_SAVED_TO_MENU_SUCCESSFULLY}
        </MessageBar>
      ) : notificationState === MenuPublishedState.ITEM_EDITED_IN_BANK_SUCCESSFULLY ? (
        <MessageBar intent="success" layout="singleline">
          {MenuPublishedState.ITEM_EDITED_IN_BANK_SUCCESSFULLY}
        </MessageBar>
      ) : notificationState === MenuPublishedState.UNPUBLISHED_CHANGES ? (
        <MessageBar intent="warning" layout="singleline">
          {MessageBarText.UNPUBLISHED_CHANGES}
        </MessageBar>
      ) : null}
    </div>
  );
};
